/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ExportAcceptedBidsCsv$Params {
  auctionId: number;
  'X-API-Version'?: string;
      body?: {
'columns'?: Array<string>;
}
}

export function exportAcceptedBidsCsv(http: HttpClient, rootUrl: string, params: ExportAcceptedBidsCsv$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, exportAcceptedBidsCsv.PATH, 'post');
  if (params) {
    rb.query('auctionId', params.auctionId, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'text/csv', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

exportAcceptedBidsCsv.PATH = '/api/csv-export/accepted-bids';
